export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_SET_STATE = 'MODAL_SET_STATE';
export const MODAL_CLOSE = 'MODAL_CLOSE';

export enum ModalIds {
    SHORTCUTS = 'SHORTCUTS',
    SHARE = 'SHARE',
    ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
    AUTH = 'AUTH',
    AUTH_IN_APP = 'AUTH_IN_APP',
}
